import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.connector.DOC}
  mutation CreateIntegrationConnector(
    $tenantId: ID!
    $zoneId: ID!
    $input: IntgConnectorInput!
    $apiKey: String!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        createIntgConnector(input: $input, apiKey: $apiKey) {
          ...FragmentIntegrationConnector
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.CreateIntegrationConnectorMutation,
    ents.core.integrations.Connector,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'createIntgConnector',
        fragments.connector.TRANSFORMER,
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.CreateIntegrationConnectorMutation,
  ents.core.integrations.Connector,
  graphql.schema.CreateIntegrationConnectorMutationVariables
>({ query: DOC, transformer: TRANSFORMER })
